import { IQueryMediator } from 'core-ts-types';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';
import { IRawTimeOccurrenceDatatype, ITimeOccurrenceDatatype } from '../datastore/time/data_types';

// Given an array of raw TimeOccurrence data, make new TimeOccurrences and add it to data source.
function addRawTimesCommandDefinition(
  defineCommand: any,
  addRawTimeCommand: any,
  ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
  QueryMediator: IQueryMediator
) {
  return defineCommand(
    'addRawTimesCommand',
    function addRawTimesCommand(deferred: any, rawTimeOccurrencesData: IRawTimeOccurrenceDatatype[]) {
      let builtTimes: ITimeOccurrenceDatatype[] = [];

      _.map(rawTimeOccurrencesData, function (rawTimeOccurrenceData: IRawTimeOccurrenceDatatype) {
        addRawTimeCommand(rawTimeOccurrenceData).then((builtTime: ITimeOccurrenceDatatype) => {
          QueryMediator.runQueries(ngTimeOccurrenceDataSource);
          builtTimes.push(builtTime);
        });
      });

      deferred.resolve(builtTimes);
    }
  );
}

angular.module('ui-ng-calendar').factory('addRawTimesCommand', addRawTimesCommandDefinition);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/commands/add_raw_times.ts